import { MixPanel } from '@/mixin/mixpanel'

// Set navsource query and its params (if have any) to current route
// NOTE: This function is created for beforeEnter navigation guard in route's config obj
export const setNavSource = (to, from, next) => {
  if (from.name === null || to.query?.navsource || to.query?.isSetNavsource === false) {
    next()
    return
  }

  to.query.navsource = from.name

  if (Object.keys(from.params).length > 0) {
    const params = JSON.stringify(from.params)
    to.query.navsourceparam = params
  }

  next()
}

export const redirectLiveview2 = async () => {
  MixPanel.methods.track('Open Live View 2')
  const url = `${window.location.protocol}//${window.location.host}/liveview-2/`

  setTimeout(() => {
    window.location.href = url
  }, 500)
}
